// app
import * as api from "./api.js"
import * as types from "./types.js"

/*
 * LIST
 */
const listRequest = (table) => {
    return {
        type: types.LIST_REQUEST,
        payload: {
            table
        }
    }
}

const listReceived = (table, data) => {
    return {
        type: types.LIST_RECEIVED,
        payload: {
            table,
            data
        }
    }
}

const listError = (table, error) => {
    return {
        type: types.LIST_ERROR,
        payload: {
            table,
            error
        },
        error: true
    }
}

export function list(table) {
    return (dispatch) => {
        dispatch(listRequest(table))
        return api.get(table)
        .then(res => {
            if (res.status !== 200) {
                dispatch(listError(table, res.statusText))
            } else {
                return res.json()
                .then(data => {
                    dispatch(listReceived(table, data))
                })
            }
        })
    }
}



/** WEBPACK FOOTER **
 ** ./src/actions/ref/actions.js
 **/